var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WsMain',_vm._l((_vm._value),function(stage,stageIndex){return _c('AppEvaluationStageExcuteTypeItem',{key:stageIndex,attrs:{"value":stage},on:{"input":function($event){return _vm.$_onInput($event,stageIndex)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }